/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { RetailerTranslationUpdate } from './RetailerTranslationUpdate';

export type UpdateRetailerRequest = {
    companyId?: number;
    isContainPii?: boolean;
    status?: UpdateRetailerRequest.status;
    effectiveFrom?: string;
    effectiveTo?: string;
    regions?: Array<'AB' | 'BC' | 'MB' | 'NB' | 'NL' | 'NT' | 'NS' | 'NU' | 'ON' | 'TB' | 'PE' | 'QC' | 'SK' | 'YT'>;
    translations?: Array<RetailerTranslationUpdate>;
    isExcludedFromCompanyPostProcessors?: boolean;
    sponsorCode?: string;
    isEnabledBaseIssuance?: boolean;
    baseIssuanceExcludedProductIds?: Array<string>;
};

export namespace UpdateRetailerRequest {

  export enum status {
    ACTIVE = 'ACTIVE',
    DISABLED = 'DISABLED',
  }


}

